// PATH: SaberpDeals/frontend/src/pages/LoginPage.tsx
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';

export default function LoginPage() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [busy, setBusy] = useState(false);

    async function submit() {
        setError(null);
        setBusy(true);
        try {
            await login(username.trim(), password);
            navigate('/catalog');
        } catch (e: any) {
            setError(e?.response?.data?.message ?? 'Invalid username or password.');
        } finally {
            setBusy(false);
        }
    }

    return (
        <div className="min-h-screen flex items-center justify-center px-4">
            <div className="w-full max-w-sm">
                <div className="flex items-baseline gap-3 mb-8 justify-center">
                    <h1 className="font-disp text-3xl font-semibold tracking-tight">SAB ERP</h1>
                    <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.14em] text-forest">
                        Deals &amp; Commissions
                    </span>
                </div>

                <div className="bg-card border border-line rounded-2xl p-7 shadow-sm">
                    <h2 className="font-disp text-xl font-semibold mb-1">Sign in</h2>
                    <p className="text-[13px] text-ink-3 mb-6">Enter your deals-portal credentials.</p>

                    {error && (
                        <div className="mb-4 rounded-lg bg-clay-soft border border-clay/30 px-3 py-2 text-[13px] text-clay">
                            {error}
                        </div>
                    )}

                    <label className="block text-[11px] font-semibold text-ink-2 uppercase tracking-wide mb-1.5">Username</label>
                    <input
                        className="w-full text-sm bg-card border border-line-2 rounded-lg px-3 py-2.5 mb-4 outline-none focus:border-forest-2 focus:ring-2 focus:ring-forest-soft"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && submit()}
                        autoFocus
                    />

                    <label className="block text-[11px] font-semibold text-ink-2 uppercase tracking-wide mb-1.5">Password</label>
                    <input
                        type="password"
                        className="w-full text-sm bg-card border border-line-2 rounded-lg px-3 py-2.5 mb-6 outline-none focus:border-forest-2 focus:ring-2 focus:ring-forest-soft"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onKeyDown={(e) => e.key === 'Enter' && submit()}
                    />

                    <button
                        disabled={busy || !username || !password}
                        onClick={submit}
                        className="w-full bg-forest text-paper font-semibold text-sm rounded-lg py-3 hover:bg-forest-2 disabled:opacity-50 transition"
                    >
                        {busy ? 'Signing in…' : 'Sign in'}
                    </button>
                </div>
            </div>
        </div>
    );
}
